import { getApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage, type MessagePayload } from "firebase/messaging";
import { collection, doc, getDocs, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // tu inicialización existente

const VAPID_PUBLIC_KEY = import.meta.env.VITE_FCM_VAPID_KEY as string;

export async function ensurePushPermissionAndToken(tenantId: string, uid: string) {
  if (!(await isSupported())) return null;

  if (!VAPID_PUBLIC_KEY) {
    console.error("VITE_FCM_VAPID_KEY no está configurada: no se puede obtener el token de push.");
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  // Registramos el SW de mensajería en un scope propio para que no choque
  // con el Service Worker principal de la PWA (Workbox, scope "/").
  const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
    scope: "/firebase-cloud-messaging-push-scope",
  });
  const messaging = getMessaging(getApp());
  const token = await getToken(messaging, { vapidKey: VAPID_PUBLIC_KEY, serviceWorkerRegistration: swReg });
  if (!token) return null;

  // guarda el token en Firestore (ID del doc = token)
  await setDoc(
    doc(db, `tenants/${tenantId}/users/${uid}/fcmTokens/${token}`),
    {
      createdAt: serverTimestamp(),
      ua: navigator.userAgent,
      platform: navigator.platform,
      enabled: true,
      topics: ["general", "payments", "classReminder"],
    },
    { merge: true }
  );

  return token;
}

export function onForegroundPush(cb: (payload: MessagePayload) => void) {
  const messaging = getMessaging();
  onMessage(messaging, cb);
}

export async function listUserTokens(tenantId: string, uid: string): Promise<string[]> {
  const snap = await getDocs(collection(db, `tenants/${tenantId}/users/${uid}/fcmTokens`));
  const tokens: string[] = [];
  snap.forEach((d) => tokens.push(d.id));
  return tokens;
}
